import {
  BrowserClient,
  getDefaultIntegrations,
  Scope,
  makeFetchTransport,
  defaultStackParser,
} from "@sentry/react";
import { getCurrentEnvironment } from "./utility/environment-helper";

export let scope: Scope;

export async function initializeSentry() {
  // to avoid conflicts with other Sentry instances in the browser,
  // filter out integrations that use global variables
  const integrations = getDefaultIntegrations({}).filter(
    (defaultIntegration) => {
      return !["BrowserApiErrors", "Breadcrumbs", "GlobalHandlers"].includes(
        defaultIntegration.name,
      );
    },
  );

  const client = new BrowserClient({
    dsn: "https://750c12cdb76b353947bac8812a9755cc@sentry.prod.bloomberg.com/740",
    environment: getCurrentEnvironment(),
    integrations: integrations,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
  });

  scope = new Scope();
  scope.setClient(client);
  client.init(); // initializing has to be done after setting the client on the scope

  return scope;
}
